import React, { useState } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import { Button } from 'react-bootstrap';
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const UploadAccreditationComp = (props) => {
  // console.log(props);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [fileRekomendasi, setFileRekomendasi] = useState('');

  const handleUpload = async () => {
    try {
      setLoading(true);
      setDisabled(true);
      if (fileRekomendasi === '') {
        MySwal.fire({
          icon: 'error',
          title: 'Oops, Error',
          text: 'Belum ada file terupload!',
        });
        return false;
      }

      const formData = new FormData();
      formData.append('fileSkorBab', fileRekomendasi);
      formData.append('idKegiatanAkreditasi', props?.accreditation?.id);

      const { data } = await axios({
        url: `/skor/sync-skor-from-online`,
        method: 'POST',
        data: formData,
        headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
      });
      // console.log(data);
      // return false;
      setLoading(false);
      setDisabled(false);
      MySwal.fire({
        icon: 'success',
        title: 'Sukses',
        text: 'Berhasil mengimport data!',
      });
      props.fetch();
      props.close();
    } catch (err) {
      console.log(err?.response?.data?.message);
      MySwal.fire({
        icon: 'error',
        title: 'Oops, Error!',
        text: `Pastikan menggunakan file import yg sesuai.`,
      });
    }
  };

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="filePath" className="col-sm-4 col-form-label" required>
          File Rekomendasi
        </label>
        <div className="col-12">
          <input
            type="file"
            className="form-control"
            id="filePath"
            onChange={(e) => setFileRekomendasi(e.target.files[0])}
          />
        </div>
      </div>
      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleUpload()}
          >
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UploadAccreditationComp;
